import { useQuery } from "@tanstack/react-query";

import { fetchDataGet } from "@/core/api/api-methods";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { reportingEndpoints } from "@/features/reporting/api/endpoints";
import type { ReportingRangeParams } from "@/features/reporting/api/dto";
import {
  compactQuery,
  parseOverview,
} from "@/features/reporting/api/parse";

/** Vue consolidée gateway (`GET /api/v1/Reporting/overview`). */
export const useReportingOverview = (
  params: ReportingRangeParams = {},
  enabled = true
) =>
  useQuery({
    queryKey: QUERY_KEYS.REPORTING_OVERVIEW(params.from, params.to),
    queryFn: async () => {
      const raw = await fetchDataGet<unknown>({
        url: reportingEndpoints.gateway.overview,
        queryParams: compactQuery({ from: params.from, to: params.to }),
      });
      return parseOverview(raw);
    },
    retry: (failureCount, error) =>
      !/401|403/.test(error?.message ?? "") && failureCount < 1,
    staleTime: 5 * 60 * 1000,
    enabled,
  });
